import React from "react";

import { Typography, useTheme } from "@material-ui/core";
import { orange } from "@material-ui/core/colors";
import { HIDE_FEATURE_BADGES } from "../../utils/constants";

export const BetaBadge = ({ ml = 1, mt = 0, label, ...props }) => {
  const theme = useTheme();
  const id = label?.toLowerCase()?.replace(/ /g, "-"); // Create an ID from the label

  if (HIDE_FEATURE_BADGES) return null;
  return (
    <Typography
      component="span"
      variant="overline"
      id={id}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center", // Ensures horizontal centering
        backgroundColor: orange[800],
        color: "white",
        borderRadius: theme.shape.borderRadius,
        padding: "0px 8px",
        marginLeft: theme.spacing(ml),
        marginTop: theme.spacing(mt),
        fontSize: "0.75rem", // Adjust font size to better fit the new height
        height: "18px", // Reduced height for a smaller badge
        lineHeight: "18px", // Line height equal to height to center text vertically
      }}
    >
      BETA
    </Typography>
  );
};

export const NewBadge = ({ ml = 1, mt = 0, label, ...props }) => {
  const theme = useTheme();
  const id = label?.toLowerCase()?.replace(/ /g, "-"); // Create an ID from the label

  if (HIDE_FEATURE_BADGES) return null;
  return (
    <Typography
      component="span"
      variant="overline"
      id={id}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center", // Ensures horizontal centering
        backgroundColor: theme.palette.primary.main,
        color: "white",
        borderRadius: theme.shape.borderRadius,
        padding: "0px 8px",
        marginLeft: theme.spacing(ml),
        marginTop: theme.spacing(mt),
        fontSize: "0.75rem", // Adjust font size to better fit the new height
        height: "18px", // Reduced height for a smaller badge
        lineHeight: "18px", // Line height equal to height to center text vertically
      }}
    >
      NEW
    </Typography>
  );
};
